import { render } from "./ScrollMenu.vue?vue&type=template&id=25af13b3&scoped=true"
import script from "./ScrollMenu.vue?vue&type=script&lang=js"
export * from "./ScrollMenu.vue?vue&type=script&lang=js"

import "./ScrollMenu.vue?vue&type=style&index=0&id=25af13b3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25af13b3"]])

export default __exports__